// import React, { useRef, useEffect, useContext, useState } from 'react';
import React, { useRef, useEffect, useContext } from 'react';
import ReactDOM from 'react-dom';

import { TimelineMax } from 'gsap';

import { DialogContext, dialogCreators } from 'src/providers/DialogProvider';

interface IDialogProps {
    title: string;
}

const Dialog: React.FC<IDialogProps> = (props) => {
    const backgroundRef = useRef();
    const dialogRef = useRef();
    const context = useContext<dialogCreators>(DialogContext);

    const closeDialog = () => {
        const tl = new TimelineMax();
        tl.fromTo(backgroundRef.current, { opacity: 1 }, { opacity: 0, duration: 0.3 }, 0.1);
        tl.fromTo(dialogRef.current, { opacity: 1 }, { opacity: 0, duration: 0.3 });
    };

    useEffect(() => {
        const tl = new TimelineMax();
        tl.fromTo(backgroundRef.current, { opacity: 0 }, { opacity: 1, duration: 0.3 });
        tl.fromTo(dialogRef.current, { opacity: 0, marginTop: '-30px' }, { opacity: 1, marginTop: '0', duration: 0.3 }, 0.1);
    }, []);

    useEffect(() => {
        if (context.beginHide) {
            closeDialog();
        }
    }, [context.beginHide]);

    const renderDialog = () => {
        return (
            // <div ref={backgroundRef} className="dlc-dialog-background-2" onClick={context.hideDialog}>
            <div ref={backgroundRef} className="dlc-dialog-background-2">
                <div ref={dialogRef} className="dlc-dialog" onClick={(e) => e.stopPropagation()}>
                    <div className="dlc-dialog-close" onClick={context.hideDialog}>
                        <span className="dlc-dialog-close-icon">
                            <i className="fas fa-times" />
                        </span>
                    </div>
                    <div className="dlc-dialog-header">{props.title}</div>
                    <div className="dlc-dialog-body">{props.children}</div>
                </div>
            </div>
        );
    };

    return ReactDOM.createPortal(renderDialog(), document.querySelector('#dialog-portal'));
};

export const DialogActionBar: React.FC<{}> = (props) => {
    return (
        <div className="dlc-dialog-action-bar">
            {React.Children.map(props.children, (child: React.ReactElement) =>
                React.cloneElement(child, {
                    className: child.props.className + ' mr-2',
                })
            )}
        </div>
    );
};

export default Dialog;



// WEBPACK FOOTER //
// ./src/components/common/Dialog.redesign.tsx